import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Offers from "../components/landing/Offers";
import Services from "../components/landing/Services";
import About from "../components/landing/About";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";

export default function Home() {
  const [services, setServices] = useState([]);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    api.get("/api/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/api/offers").then((r) => setOffers(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-paper min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Offers offers={offers} />
        <Services services={services} />
        <About />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
